/** Only fixed, reviewed copy may cross the recovery error boundary. */
const SAFE_RECOVERY_MESSAGES = new Map<string, string>([
	[
		"Allow popups to restore with a linked account, then try again.",
		"Allow popups to restore with a linked account, then try again.",
	],
	["Recovery cancelled.", "Recovery cancelled."],
	[
		"Recovery timed out. Please try again.",
		"Recovery timed out. Please try again.",
	],
	[
		"Provider sign-in was not completed. Please try again.",
		"Provider sign-in was not completed. Please try again.",
	],
	[
		"Sign-in was not completed. Please try again.",
		"Sign-in was not completed. Please try again.",
	],
	["Enter your decryption password.", "Enter your decryption password."],
	[
		"Incorrect password. Please try again.",
		"Incorrect password. Please try again.",
	],
	[
		"Unable to decrypt this backup. Please try again.",
		"Unable to decrypt this backup. Check your decryption password and try again.",
	],
	[
		"No cloud backup found. Please set up cloud backup first.",
		"No cloud backup is available for this account. Use your backup file or recovery phrase.",
	],
	[
		"Backup import was superseded",
		"The active wallet changed. Start recovery again.",
	],
	[
		"Backup import continuation was superseded",
		"The active wallet changed. Start recovery again.",
	],
]);

export function recoveryErrorMessage(error: unknown): string {
	if (error instanceof Error) {
		const message = SAFE_RECOVERY_MESSAGES.get(error.message);
		if (message) {
			return message;
		}
	}
	return "Recovery could not be completed. Check your decryption password and try again.";
}
